/*
 * @Descripttion: 
 * @version: 
 * @Author: HanBeiBei
 * @Date: 2020-08-20 18:37:12
 * @LastEditors: HanBeiBei
 * @LastEditTime: 2023-10-31 11:33:31
 */
import { message } from 'antd';
import { Route, withRouter } from 'react-router-dom';

export default async (url = "", config = {}) => {
    try {
        const json = await fetch(url, { credentials: 'include', ...config });
        const res = await json.json();

        if (res.status != 1) message.error(res.msg);

        return res;
    } catch (error) {
        console.log(error);
        fetch(`/accept/error?title=接口返回错误&content=${JSON.stringify(error)}&url=${url}`, { credentials: 'include' });
        return false
    }
};

export const qs = async (url = "", config = {}) => {
    try {
        const json = await fetch(`/qiansheng/${url}`, { credentials: 'include', ...config });
        const res = await json.json();

        if (res.code != 200) message.error(res.message);
        if (res.code == 401) {
            message.error(res.message);
            location.href = "/login"
            return
        }

        return res;
    } catch (error) {
        console.log(error);
        message.error(error.message || "请求错误！");
        return false
    }
};



// WEBPACK FOOTER //
// ./src/method/request.js